import { AlertCircle, ChevronRight, ChevronUp, Info } from 'lucide-react';
import styled from 'styled-components';
import { Button } from 'components';

export const DisclaimerBox = styled.div.attrs({
  className: 'flex w-full flex-col gap-3',
})``;

export const DisclaimerBlock = styled.div.attrs({
  className: 'flex flex-col gap-1',
})``;

export const DisclaimerToggle = styled.button.attrs({
  type: 'button',
  className: 'flex w-full cursor-pointer items-center gap-2 text-left',
})``;

export const DisclaimerIcon = styled(Info).attrs({
  className: 'size-4 shrink-0',
  'aria-hidden': true,
})``;

export const DisclaimerTitle = styled.span.attrs({
  className: 'min-w-0 flex-1 truncate text-xs font-medium',
})``;

export const ExpandedIcon = styled(ChevronUp).attrs({
  className: 'size-4 shrink-0',
  'aria-hidden': true,
})``;

export const CollapsedIcon = styled(ChevronRight).attrs({
  className: 'size-4 shrink-0',
  'aria-hidden': true,
})``;

export const DisclaimerDetails = styled.div.attrs({
  className: 'flex flex-col items-start gap-1 pl-6',
})``;

export const DisclaimerText = styled.p.attrs({
  className: 'text-xs text-muted-foreground',
})``;

export const DisclaimerSeparator = styled.hr.attrs({
  className: 'w-full border-t border-border',
})``;

export const ObjectionRow = styled.div.attrs({
  className: 'flex w-full items-center gap-2',
})``;

export const ObjectionIcon = styled(AlertCircle).attrs({
  className: 'size-4 shrink-0 text-destructive',
  'aria-hidden': true,
})``;

export const ObjectionText = styled.p.attrs({
  className: 'min-w-0 flex-1 text-xs font-medium text-destructive',
})``;

export const ObjectionAction = styled(Button).attrs({
  type: 'button',
  variant: 'link',
  size: 'xs',
  className: 'h-auto p-0',
})``;
